export default function Testimonial() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-11 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
              <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase">Community Voices</span>
            </div>

            <div className="mb-8">
              <i className="ri-double-quotes-l text-6xl text-teal-600 opacity-50"></i>
            </div>

            <blockquote className="text-3xl md:text-4xl font-serif text-gray-900 leading-relaxed mb-8">
              This platform helped me furnish my apartment without spending a dime while helping others declutter their homes. It's a win-win for everyone and the planet.
            </blockquote>

            <div className="flex items-center gap-3">
              <div>
                <div className="font-bold text-gray-900 text-lg">Sarah Mitchell</div>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex items-center gap-1 bg-teal-100 text-teal-700 px-3 py-1 rounded-full">
                    <i className="ri-star-fill text-sm"></i>
                    <span className="text-xs font-semibold">Verified Swapper</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7e91493310bfcd4ba623d4085a83c885.jpg"
                alt="Sarah Mitchell"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
